define.alias("shared/components/shared/wizards/device-setup/step-one", "calendar/components/shared/wizards/device-setup/step-one");